export function GuidePane(_: { state: string; vendorId?: string }) {
  return null;
}
